<div class="app__block container-fluid">
  <app-tour-offers-content class="row"></app-tour-offers-content>
  <div class="row">
    <app-offer-me-tour-card class="col-12 offset-md-2 col-md-8 offset-lg-3 col-lg-6"></app-offer-me-tour-card>
  </div>
</div>
<app-seo-linking [display]="{ popular: true, resorts: true, hotels: false }"></app-seo-linking>
<div class="app__block" *ngIf="page$ | async as page">
  <div class="container" *ngIf="(page | fieldTranslation)?.html as html">
    <app-seo-text [seoText]="html"></app-seo-text>
  </div>
</div>
<ng-template appHeaderSubtitle>
  <app-subtitle-link
    *ngIf="resortPageInfo$ | async as info"
    [names]="info.resort.countryNames"
    [url]="info.resort.countryUrl">
  </app-subtitle-link>
</ng-template>
<ng-template appBreadcrumbsWidget>
  <ng-container *ngIf="hotels$ | async as hotels">
    <div class="tour-offers-sort" *ngIf="hotels.length > 0">
      <span class="tour-offers-sort__label">{{ 'TourOffersPage.Sort.Label' | translate }}:</span>
      <ng-select
        class="tour-offers-sort__select"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
        [items]="sortOptions"
        bindValue="value"
        [ngModel]="sort$ | async"
        (ngModelChange)="changeSort($event)">
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          {{ item.label | translate }}
        </ng-template>
      </ng-select>
    </div>
  </ng-container>
</ng-template>
